import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryManagedObjectsNames } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithArray } from '@utils/formatter';

import { TDumpConsistencyIdAndPath } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_MANAGED_NAMES } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryManagedObjectNames {
	consistencyCheckManagedObjectNames: TSelectOption<string>[];
	isLoadingConsistencyCheckManagedObjectNames: boolean;
}

const useConsistencyCheckHistoryManagedObjectNames = (
	params: Partial<TDumpConsistencyIdAndPath>,
): IUseConsistencyCheckHistoryManagedObjectNames => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_MANAGED_NAMES, params],
		queryFn: extractQueryParams(getConsistencyCheckHistoryManagedObjectsNames),
		select: (data: string[]) => optionsFormattedWithArray(data),
		enabled: [!!params.dumpConsistencyId, !!params.dataModelPathId],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckManagedObjectNames: data || [],
		isLoadingConsistencyCheckManagedObjectNames: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryManagedObjectNames;
